import _each from "lodash/each";
import { gsap, Cubic } from "gsap";
import store from "~/js/store/store";
import Common from "~/js/common/common";
import VimeoSection from "~/js/common/vimeo-section";
import _concat from "lodash/concat";
export default class News {
  constructor(viewSelector) {
    new VimeoSection()
    this.view = document.querySelector(viewSelector || ".c-brands-news");
    if (!this.view) {
      return;
    }
    this.loadNumber = this.view.getAttribute("data-number") || store.state.constant.brand.NEWS_LOAD_COUNT;
    this.readLength = "";
    if (!this.view) {
      return;
    }
    this.moreButton = this.view.querySelector(".js-morebutton");
    this.lessButton = this.view.querySelector(".js-lessbutton");
    if (!this.moreButton) {
      return;
    }
    this.setup();
  }

  setup() {
    let invisibles = this.view.querySelectorAll(".js-news__invisible");
    let insiviblesSp = this.view.querySelectorAll(".js-news__invisible_sp");
    if(invisibles.length <= 0 && insiviblesSp.length <= 0){
      this.moreButton.remove()
      this.lessButton.remove()
    }

    if (this.moreButton) {
      this.moreButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open();
        this.view.classList.add("open");
        Common.addNoscrollAllChildren(this.view);
      });
    }
    if (this.lessButton) {
      this.lessButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.view.classList.remove("open");
        this.closeAll();
      });
    }
  }

  open() {
    let invisibles = this.view.querySelectorAll(".js-news__invisible");
    let insiviblesSp = this.view.querySelectorAll(".js-news__invisible_sp");
    let count = 0;
    if (Common.isSPSize()) {
      let result = [];
      _each(insiviblesSp, (elm) => {
        result.push(elm);
      });
      _each(invisibles, (elm) => {
        result.push(elm);
      });
      invisibles = result;
    }
    _each(invisibles, (elm, index) => {
      if (!elm.classList) {
        return;
      }
      count += 1;
      if (count <= this.loadNumber) {
        elm.classList.add("appear");
        elm.classList.add("js-news__visible");
        elm.classList.remove("js-news__invisible_sp");
        elm.classList.remove("js-news__invisible");
        gsap.to(elm, {
          opacity: 1,
          delay: 0.1 * index,
          duration: 0.7,
          ease: Cubic.easeOut
        });
        if (index === 0) {
          elm.focus()
        }
      }
    });
    this.checkLoadComplete();
  }

  closeAll() {
    let visibles = this.view.querySelectorAll(".js-news__visible");
    let size = visibles.length;
    _each(visibles, (elm, index) => {
      gsap.to(elm, {
        opacity: 0,
        height: 0,
        marginBottom: 0,
        delay: 0.03 * (size - index),
        duration: 0.28,
        ease: Cubic.easeOut,
        onComplete: () => {
          elm.classList.remove("appear");
          elm.classList.remove("js-news__visible");
          Common.removeNoscroll(elm);
          gsap.delayedCall(0.02, () => {
            elm.classList.add("js-news__invisible");
            elm.style = null;
          });
        }
      });
    });
    gsap.delayedCall(0.2, () => {
      this.moreButton.classList.remove("invisible");
      this.lessButton.classList.add("invisible");
    });
  }

  checkLoadComplete() {
    const invisibles = this.view.querySelectorAll(".js-news__invisible");
    if (!invisibles.length) {
      this.loadFinish();
    }
  }

  // すべてのニュースを読み込み完了した
  loadFinish() {
    this.moreButton.classList.add("invisible");
    this.lessButton.classList.remove("invisible");
  }

  /*addNoscrollAllChildren(parentNode) {
    const allChildren = parentNode.children;
    _each(allChildren, (elm, index) => {
      this.addNoscroll(elm);
    });
  }

  addNoscroll(elm) {
    elm.classList.add("js-noscroll");
    this.addNoscrollAllChildren(elm);
  }*/
}
